// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Minus = createIcon(
  <path
    clipRule="evenodd"
    d="M6.59863 11.9999C6.59863 11.5028 7.00158 11.0999 7.49863 11.0999L16.5016 11.0999C16.9987 11.0999 17.4016 11.5028 17.4016 11.9999C17.4016 12.497 16.9987 12.8999 16.5016 12.8999L7.49863 12.8999C7.00158 12.8999 6.59863 12.497 6.59863 11.9999Z"
    fillRule="evenodd"
  />,
);
